<template>
  <div>
    <div class="message-box">
      <div class="message-text">
        <div class="w-1400">
          <div class="message-text-title">
            <div class="message-text-title-text">
              免费信息发布大厅
              <img class="hot-img" src="../../static/index/hot.png" alt="热门"/>
            </div>
            <div class="message-big-img" @click="goMessage">
              <img src="../../static/index/big.png" alt="放大页面"/>
            </div>
          </div>
          <!-- 聊天消息列表 -->
          <!-- 聊天消息列表 -->
          <div class="message-text-list" ref="messageListRef" @scroll="handleMessageListScroll">
            <!-- 加载提示 -->
            <div v-if="showLoadingTip" class="loading-tip">
              <i class="el-icon-loading"></i>
              <span>正在加载历史消息...</span>
            </div>
            <div class="message-text-list-item-box" v-for="(item, index) in messageList" :key="index">
              <div class="message-text-list-item" v-if="item.people_id != userInfo.id">
                <div class="message-text-list-item-name">
                  <img :src="item.avatar" alt="用户头像" class="message-avatar"/>
                  <!-- <div class="message-avatar">{{ item.name.slice(0, 2) }}</div> -->
                  <div class="user-info">
                    <div class="user-info-name" v-if="item.company || item.people">
                      {{ item.company || $utils.maskPhoneNumber(item.people.mobile) }}
                    </div>
                    <div class="user-info-time">{{ item.created_at }}</div>
                  </div>
                </div>
                <div class="message-text-list-item-content">
                  {{ item.message }}
                </div>
              </div>
              <div v-else class="right-show">
                <div class="message-text-list-item-name">
                  <div class="message-text-list-item-content">
                    {{ item.message }}
                  </div>
                  <div class="user-info">
                    <div class="user-info-name" v-if="item.company || item.people">
                      {{ item.company || $utils.maskPhoneNumber(item.people.mobile) || '' }}
                    </div>
                    <div class="user-info-time">{{ item.created_at }}</div>
                  </div>
                  <img :src="item.avatar" alt="用户头像" class="message-avatar"/>
                </div>

              </div>
            </div>
          </div>
        </div>
        <div class="message-text-buttom">
          <div class="w-1400">
            <div class="send-messsage-box">
              <input v-model="tockInner" placeholder="请输入聊天内容...." placeholder-class="input-placeholder"
                     @click="handleFocus" @keyup.enter="sendMessage"/>
              <div class="send-button hit-cursor" @click="sendMessage">
                <img src="../../static/index/send.png" alt="发送消息icon"/>
                发送
              </div>
            </div>
          </div>
        </div>
      </div>
      <img class="message-box-img" src="../../static/index/index_message.png" alt=""/>
    </div>
  </div>
</template>
<script>
import ws from "../../utils/webSocket.js";
import {
  chat_list,
} from "@/api/modules/home";

export default {
  name: "message",
  data() {
    return {
      isFocus: false,
      page: 1,
      limit: 10,
      messageList: [],
      showLoadingTip: false,
      totalPage: 0,
      isLoadingMore: false, // 是否正在加载更多消息
      tockInner: '',
      sendTrue: false
    }
  }
  ,
  mounted() {
    this.getChatList()
  },
  watch: {
    messageList(newVal) {
      this.scrollToBottom();
    },
    isLogin(newValue) {
      if (newValue) {
        this.$store.dispatch("GET_USER_INFO");
        this.handleFocus()
      }
    },
    userInfo: {
      handler(newVal) {
        if (!newVal.mobile) {
          this.sendTrue = false
        } else {
          this.sendTrue = true
        }
      },
      deep: true,
      immediate: true
    }
  },
  computed: {
    userInfo() {
      return this.$store.getters.userInfo;
    },
    isLogin() {
      return this.$store.getters.isLogin;
    }
  },
  methods: {
    // 获取聊天内容
    getChatList() {
      chat_list({page: this.page, limit: this.limit}).then((res) => {
        this.messageList = [...this.messageList, ...res.data.data.data];
        this.messageList.sort(
            (a, b) => new Date(a.created_at) - new Date(b.created_at)
        );
        this.scrollToBottom();
        this.totalPage = res.data.data.last_page;
      });
    },
    // 获取焦点的时候初始化聊天
    handleFocus() {
      if (!this.isLogin) {
        this.$confirm("请先登录", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$router.push("/login");
        });
        return;
      }
      if (this.isFocus) {
        return;
      }
      const self = this;
      const handler = {
        onopen: function () {
          self.isFocus = true;
        },
        onmessage: function (event) {
          let data = JSON.parse(event.data);
          if (!data) {
            return;
          }
          if (data.type === "send") {
            self.messageList.push({
              creator: "",
              company: data.people.company || "--",
              created_at: data.time || "--",
              message: data.message,
              avatar: data.people.avatar || "",
              people_id: data.people.people_id || "",
            });
          }
        },
        onclose: function () {
          // console.log("WebSocket 连接已关闭");
          self.isFocus = false;
        },
        onerror: function () {
          self.isFocus = false;
          // console.log("WebSocket 发生错误");
        },
        ping: function () {
        },
      };
      const socket = ws(
          "wss",
          this.$api.wsPath,
          443,
          "",
          {},
          handler,
          30000,
          5000,
          "arraybuffer"
      );
      socket.connect();
      this.socket = socket;
    },
    // 发送聊天消息
    sendMessage() {
      if (!this.isLogin) {
        this.$confirm("请先登录", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$router.push("/login");
        });
        return;
      }
      if (!this.sendTrue) {
        this.$confirm("请先绑定手机号", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
          this.$router.push("/bindPhone");
        });
        return
      }
      if (this.userInfo.status != 1) {
        this.$message.error('您的账号已被禁用')
        return
      }

      if (!this.mixCheckUserAudit()) {
        return
      }

      if (!this.tockInner.trim()) {
        this.$confirm("消息不能为空", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }).then(() => {
        });
        return;
      }

      // console.log(this.socket, this.socket.ws, this.socket.ws.readyState);
      if (this.socket && this.socket.ws && this.socket.ws.readyState === 1) {
        this.socket.send(
            JSON.stringify({
              type: "send",
              message: this.tockInner,
              people_id: this.userInfo.id,
            })
        );
        this.tockInner = "";
      } else {
        this.$message && this.$message.error
            ? this.$message.error("WebSocket 未连接")
            : alert("WebSocket 未连接");
      }
    },
    goMessage() {
      this.$router.push({
        path: "/message",
      });
    },
    // 聊天列表滚动 - 优化版本
    handleMessageListScroll(e) {
      // 防止重复加载
      if (this.isLoadingMore) return;

      // 当滚动到顶部100px范围内时加载更多
      if (this.page < this.totalPage && e.target.scrollTop <= 100) {
        this.isLoadingMore = true;

        // 记录当前滚动位置
        const oldScrollHeight = e.target.scrollHeight;
        const oldScrollTop = e.target.scrollTop;

        this.page++;

        // 显示加载提示
        this.showLoadingTip = true;

        chat_list({page: this.page, limit: this.limit})
            .then((res) => {
              if (res.data && res.data.data && res.data.data.data) {
                const newMessages = res.data.data.data;

                // 将新消息插入到列表前面
                this.messageList = [...newMessages, ...this.messageList];

                // 更新时间排序
                this.messageList.sort(
                    (a, b) => new Date(a.created_at) - new Date(b.created_at)
                );

                this.totalPage = res.data.data.last_page;

                // 保持用户当前阅读位置
                this.$nextTick(() => {
                  const newScrollHeight = e.target.scrollHeight;
                  const heightDifference = newScrollHeight - oldScrollHeight;
                  e.target.scrollTop = oldScrollTop + heightDifference;
                  // e.target.scrollTo({
                  //   top: oldScrollTop + heightDifference,
                  //   behavior: "smooth",
                  // });

                  // 隐藏加载提示
                  this.showLoadingTip = false;
                  this.isLoadingMore = false;
                });
              }
            })
            .catch((error) => {
              // console.error("加载历史消息失败:", error);
              this.page--; // 恢复页码
              this.showLoadingTip = false;
              this.isLoadingMore = false;
            });
      }
    },
    scrollToBottom() {
      if (!this.$refs.messageListRef) {
        return;
      }
      // 只有在用户没有主动滚动查看历史消息时才自动滚动到底部
      const messageList = this.$refs.messageListRef;
      const isAtBottom =
          messageList.scrollTop + messageList.clientHeight >=
          messageList.scrollHeight - 50;

      if (isAtBottom) {
        this.$nextTick(() => {
          messageList.scrollTop = messageList.scrollHeight;
        });
      }
    },

  }

}
</script>
<style lang="scss" scoped>
// 聊天加载提示样式
.loading-tip {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px 0;
  color: #666;
  font-size: 14px;
  background: rgba(255, 255, 255, 0.9);
  border-radius: 8px;
  margin: 10px 0;

  i {
    margin-right: 8px;
    color: #409eff;
    animation: rotate 1s linear infinite;
  }

  span {
    color: #666;
  }
}

.message-box {
  position: relative;
  width: 100%;
  height: 600px;

  .message-box-img {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
  }

  .message-text {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 50;

    .message-text-title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 20px 0;

      .message-text-title-text {
        font-weight: bold;
        font-size: var(--font-size-default-big);
        color: #00112b;
        line-height: 53px;

        .hot-img {
          width: 37px;
          height: 17px;
          vertical-align: baseline;
        }
      }

      .message-big-img {
        width: 24px;
        height: 24px;
        cursor: pointer;

        &:hover::after {
          content: "聊天记录";
          display: block;
          background: rgba(0, 0, 0, 0.5);
          position: absolute;
          transform: translateX(-100%);
          top: 80px;
          padding: 5px 10px;
          border-radius: 5px;
          color: #fff;
          font-size: 14px;
          font-weight: 400;
          line-height: 20px;
          text-align: center;
        }

        img {
          width: 100%;
          height: 100%;
        }
      }
    }

    .message-text-list {
      overflow-y: auto;
      box-sizing: border-box;
      position: relative;
      height: 365px;

      .message-text-list-item-box {
        display: flex;
        flex-direction: column;

      }

      .right-show {
        display: flex;
        align-self: flex-end;
        margin-bottom: 5px;
        max-width: 1000px;
        padding: 4px 14px 2px 5px;
        background: #ffffff;
        border-radius: 6px 6px 0px 6px;
        align-items: center;

        .message-text-list-item-name {
          display: flex;
          justify-content: flex-end;
          margin-bottom: 5px;
          align-items: center;

          .message-avatar {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            font-weight: 400;
            font-size: 20px;
            color: #ffffff;
            text-align: center;
            line-height: 50px;
            margin-left: 14px;
          }

          .user-info {
            // display: flex;
            // flex-direction: column;
            // justify-content: space-between;
            // align-items: flex-end;

            .user-info-name {
              font-weight: bold;
              font-size: 12px;
              color: #00112b;
              white-space: nowrap;
              text-align: right;
            }

            .user-info-time {
              font-weight: 400;
              font-size: 12px;
              color: #afafaf;
              white-space: nowrap;
            }
          }
        }

        .message-text-list-item-content {
          margin-right: 10px;
          font-weight: 400;
          font-size: 14px;
          color: #0066ff;
          line-height: 25px;
          text-align: left;
          word-break: break-all;
          /* 或者用 break-word */
          /* 或者 */
          overflow-wrap: break-word;
        }
      }

      .message-text-list-item {
        display: flex;
        align-self: flex-start;
        margin-bottom: 5px;
        max-width: 1000px;
        padding: 4px 14px 2px 5px;
        background: #ffffff;
        border-radius: 6px 6px 6px 0px;
        align-items: center;

        .message-text-list-item-name {
          display: flex;
          margin-bottom: 5px;
          align-items: center;

          .message-avatar {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            font-weight: 400;
            font-size: 20px;
            color: #ffffff;
            text-align: center;
            line-height: 50px;
            margin-right: 14px;
          }

          .user-info {
            // display: flex;
            // flex-direction: column;
            // justify-content: space-between;

            .user-info-name {
              font-weight: bold;
              font-size: 12px;
              color: #00112b;
              white-space: nowrap;
            }

            .user-info-time {
              font-weight: 400;
              font-size: 12px;
              color: #afafaf;
              white-space: nowrap;
            }
          }
        }

        .message-text-list-item-content {
          margin-left: 10px;
          font-weight: 400;
          font-size: 14px;
          color: #0066ff;
          line-height: 25px;
          word-break: break-all;
          /* 或者用 break-word */
          /* 或者 */
          overflow-wrap: break-word;
        }
      }
    }

    .message-text-buttom {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 80px;
      background: rgba(233, 241, 250, 0.5);
      border-radius: 6px 6px 6px 0px;
      z-index: 99;
      padding: 20px 0;

      .send-messsage-box {
        padding: 19px 37px;
        height: 80px;
        background: #ffffff;
        border-radius: 8px 8px 8px 8px;
        border: 1px solid #e1e4eb;
        box-sizing: border-box;
        display: flex;
        justify-content: space-between;
        align-items: center;

        input {
          width: 100%;
          height: 100%;
          border: none;
          flex: 1;
          outline: none;
          appearance: none;
          -webkit-appearance: none;
          -moz-appearance: none;
        }

        .send-button {
          width: 100px;
          height: 40px;
          background: #f2f5ff;
          border-radius: 8px 8px 8px 8px;
          border: 1px solid #bfceff;
          text-align: center;
          line-height: 40px;
          color: #0c60e6;

          img {
            width: 15px;
            height: 15px;
            vertical-align: middle;
          }
        }
      }
    }
  }
}

// 美化消息列表滚动条样式
.message-text-list {

  // 自定义滚动条样式
  &::-webkit-scrollbar {
    width: 6px; // 滚动条宽度
  }

  &::-webkit-scrollbar-track {
    background: transparent; // 轨道背景透明
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(144, 147, 153, 0.3); // 滑块颜色，半透明
    border-radius: 3px;
    transition: all 0.3s ease;

    &:hover {
      background: rgba(144, 147, 153, 0.5); // 悬停时稍微明显一点
    }
  }

  // Firefox 滚动条样式
  scrollbar-width: thin;
  scrollbar-color: rgba(144, 147, 153, 0.3) transparent;
}
</style>
